module.exports = __webpack_public_path__ + "static/media/omdb-movies-search-movie-desktop-1.0c47622c.jpg";